/* REFLOW — Black Month : comptes à rebours, temps forts, calendrier, filtres des offres, apparitions et effets ;
   sur les fiches : macaron de galerie, livraison estimée, rail des autres offres, prix qui descend.
   Une seule horloge (1 s) pour toute la page. Aucune observation du DOM (voir reflow-moonbundle-breaks-sticky) :
   les éléments sont lus une fois, puis mis à jour seulement quand leur texte change.
   À l'échéance, tout ce qui porte [data-bm-hide-end] disparaît et l'habillage est retiré. */
(function () {
  var C = window.RF_BM || {};
  var START = (C.start || 0) * 1000;
  var END = (C.end || 0) * 1000;
  var PHASES = (C.phases || []).map(function (p) { return [p[0] * 1000, p[1]]; });
  var root = document.documentElement;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  root.classList.add('bm-js');

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function phaseAt(t) {
    var label = C.label || 'Black Month';
    PHASES.forEach(function (p) { if (t >= p[0]) label = p[1]; });
    return label;
  }
  function split(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60, total: s };
  }
  function put(el, v, flip) {
    if (!el || el.textContent === v) return;
    el.textContent = v;
    if (flip && !still && el.animate) {
      el.animate([{ transform: 'translateY(-35%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
  }

  /* ---------- Horloge ---------- */
  var cds = all('[data-bm-cd]').map(function (el) {
    return { el: el, d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
  });
  var shorts = all('[data-bm-short]');
  var phases = all('[data-bm-phase]');
  var tracks = all('[data-bm-track]');
  var days = all('[data-bm-days]');
  var ended = false;

  function finish() {
    ended = true;
    all('[data-bm-hide-end]').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
    document.body.classList.remove('bm-on', 'bm-skin');
  }

  function short(p, mode) {
    if (mode === 'days') return p.d > 0 ? 'J-' + p.d : 'Dernier jour';
    if (p.d > 0) return p.d + ' j ' + pad(p.h) + ' h';
    return pad(p.h) + ' h ' + pad(p.m) + ' min';
  }

  function tick() {
    var now = Date.now();
    if (END && now >= END) { if (!ended) finish(); return; }
    var p = split(END - now);
    cds.forEach(function (c) {
      put(c.d, pad(p.d), true); put(c.h, pad(p.h), true); put(c.m, pad(p.m), true); put(c.s, pad(p.s), true);
    });
    shorts.forEach(function (el) {
      put(el, short(p, el.getAttribute('data-bm-short')));
      if (el.hidden) el.hidden = false;
      var w = el.closest('[data-bm-wrap]');
      if (w && w.hidden) w.hidden = false;
    });
    var label = phaseAt(now);
    phases.forEach(function (el) { put(el, label); });
    tracks.forEach(paintTrack);
    days.forEach(function (el) { if (!el._counting) put(el, String(p.d)); });
  }

  /* ---------- Calendrier ---------- */
  function paintTrack(tr) {
    var now = Date.now();
    var a = parseInt(tr.getAttribute('data-start'), 10) * 1000 || START;
    var b = parseInt(tr.getAttribute('data-end'), 10) * 1000 || END;
    var pct = Math.max(0, Math.min(1, (now - a) / Math.max(1, b - a)));
    var v = (Math.round(pct * 1000) / 10) + '%';
    if (tr.style.getPropertyValue('--bm-p') !== v) tr.style.setProperty('--bm-p', v);
    if (tr._painted) return;
    tr._painted = true;
    var steps = all('[data-bm-at]', tr.closest('[data-bm-timeline]') || tr);
    var current = null;
    steps.forEach(function (st) {
      var at = parseInt(st.getAttribute('data-bm-at'), 10) * 1000;
      if (at && at <= now) { st.classList.add('is-past'); current = st; }
    });
    if (current) { current.classList.remove('is-past'); current.classList.add('is-now'); }
    all('[data-bm-tick]', tr).forEach(function (t) { if (parseInt(t.getAttribute('data-bm-tick'), 10) * 1000 <= now) t.classList.add('is-past'); });
  }

  if (END) { tick(); setInterval(tick, 1000); }

  /* ---------- Offres : filtres et tri ---------- */
  all('[data-bm-deals]').forEach(function (box) {
    var list = box.querySelector('[data-bm-list]');
    var cards = all('[data-bm-card]', box);
    var count = box.querySelector('[data-bm-count]');
    var current = 'all';
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var keys = (c.getAttribute('data-f') || '').split(' ');
        var on = current === 'all' || keys.indexOf(current) !== -1;
        c.hidden = !on;
        if (on) n++;
      });
      if (count) count.textContent = count.getAttribute(n > 1 ? 'data-many' : 'data-one').replace('[n]', n);
    }
    all('[data-bm-filter]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-bm-filter');
        if (list) { if (current === 'all') list.removeAttribute('data-filtered'); else list.setAttribute('data-filtered', ''); }
        all('[data-bm-filter]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    var sort = box.querySelector('[data-bm-sort]');
    if (sort && list) {
      sort.addEventListener('change', function () {
        var k = sort.value;
        var sorted = cards.slice().sort(function (x, y) {
          var a = +x.getAttribute('data-' + (k === 'order' ? 'i' : k === 'pct' ? 'pct' : 'price'));
          var b = +y.getAttribute('data-' + (k === 'order' ? 'i' : k === 'pct' ? 'pct' : 'price'));
          if (k === 'pct' || k === 'price-desc') return b - a;
          return a - b;
        });
        sorted.forEach(function (c) { list.appendChild(c); });
        var help = list.querySelector('.bm-help-item');
        if (help) list.appendChild(help);
      });
    }
  });

  /* ---------- Fiche produit : macaron sur la photo principale ---------- */
  /* La galerie peut être reconstruite après le chargement (changement de variante, application d'offres) :
     le macaron est remis en place à ces moments-là, sans observer le DOM. */
  var sticker = document.querySelector('[data-bm-sticker]');
  function placeSticker() {
    if (!sticker || ended) return;
    var host = document.querySelector('.product-media-gallery-main-slider') || document.querySelector('[class*="media-gallery"] [class*="slider"]');
    if (!host || sticker.parentNode === host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(sticker);
    sticker.hidden = false;
  }
  if (sticker) {
    placeSticker();
    window.addEventListener('load', placeSticker);
    document.addEventListener('variant:updated', function () { setTimeout(placeSticker, 60); setTimeout(placeSticker, 600); });
    [400, 1200, 2500, 5000].forEach(function (t) { setTimeout(placeSticker, t); });
  }

  /* ---------- Fiche produit : livraison estimée en jours ouvrés (jours fériés exclus) ---------- */
  var HOL = ['2026-11-01', '2026-11-11', '2026-12-25', '2027-01-01', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-08', '2027-05-17', '2027-07-14', '2027-08-15', '2027-11-01', '2027-11-11', '2027-12-25'];
  var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function biz(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOL.indexOf(ymd(d)) === -1; }
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (biz(x)) n--; } return x; }
  function dayName(d) { return d.getDate() === 1 ? '1er' : String(d.getDate()); }
  all('[data-bm-eta]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    var cut = parseInt(el.getAttribute('data-cutoff'), 10) || 15, tpl = el.getAttribute('data-tpl');
    if (!min || !max || max < min || !tpl) return;
    var start;
    try { start = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' })); } catch (e) { start = new Date(); }
    if (!biz(start) || start.getHours() >= cut) { do { start.setDate(start.getDate() + 1); } while (!biz(start)); }
    var a = addBiz(start, min), b = addBiz(start, max);
    var same = a.getMonth() === b.getMonth();
    var ta = dayName(a) + (same ? '' : ' ' + MONTHS[a.getMonth()]);
    var tb = dayName(b) + ' ' + MONTHS[b.getMonth()];
    el.textContent = tpl.split('[a]').join(ta).split('[b]').join(tb);
    var card = el.closest('.bm-pdp__eta');
    var xmas = card && card.querySelector('[data-bm-xmas]');
    if (xmas && b < new Date(b.getFullYear(), 11, 24)) xmas.hidden = false;
  });

  /* ---------- Fiche produit : rail des autres offres ---------- */
  all('[data-bm-rail]').forEach(function (rail) {
    var box = rail.closest('.bm-more') || rail.parentNode;
    var nav = box.querySelector('[data-bm-rail-nav]');
    var prev = box.querySelector('[data-bm-rail-prev]'), next = box.querySelector('[data-bm-rail-next]');
    function step() { var it = rail.firstElementChild; return it ? it.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8; }
    function upd() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (nav) nav.hidden = max <= 4;
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft >= max - 4;
    }
    function go(dir) { rail.scrollBy({ left: dir * step(), behavior: still ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var raf = 0;
    function later() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; upd(); }); }
    rail.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    upd();
  });

  /* ---------- Fiche produit : le prix descend du prix de référence au prix Black Month ---------- */
  function euros(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€'; }
  function runTicker(el) {
    var out = el.querySelector('[data-bm-ticker-out]');
    if (!out || el._done) return;
    el._done = true;
    var from = parseInt(el.getAttribute('data-from'), 10), to = parseInt(el.getAttribute('data-to'), 10), final = out.textContent;
    if (still || !(from > to)) { el.classList.add('is-done'); return; }
    var t0 = null;
    function frame(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 1400);
      out.textContent = k < 1 ? euros(Math.round(from - (from - to) * (1 - Math.pow(1 - k, 4)))) : final;
      if (k < 1) requestAnimationFrame(frame); else el.classList.add('is-done');
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Apparitions au défilement et compteurs ---------- */
  var reveals = all('.bm-reveal');
  var counters = all('[data-bm-count-to]');
  var tickers = all('[data-bm-ticker]');
  function countUp(el) {
    var to = parseInt(el.getAttribute('data-bm-count-to'), 10) || 0;
    if (el.hasAttribute('data-bm-days') && END) to = split(END - Date.now()).d;
    if (still || !to) { el.textContent = to; return; }
    var t0 = null;
    el._counting = true;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 900);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step); else el._counting = false;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-bm-count-to')) countUp(e.target);
        if (e.target.hasAttribute('data-bm-ticker')) runTicker(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    reveals.concat(counters, tickers).forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
    counters.forEach(countUp);
    tickers.forEach(runTicker);
  }

  /* ---------- Effets au pointeur (ordinateur seulement) ---------- */
  if (fine && !still) {
    all('[data-bm-spot]').forEach(function (el) {
      var raf = 0, x = 0, y = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
        y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; el.style.setProperty('--mx', x + '%'); el.style.setProperty('--my', y + '%'); });
      });
    });
    all('[data-bm-tilt]').forEach(function (el) {
      var raf = 0, rx = 0, ry = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 6;
        rx = (0.5 - (e.clientY - r.top) / r.height) * 6;
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; el.style.setProperty('--rx', rx.toFixed(2) + 'deg'); el.style.setProperty('--ry', ry.toFixed(2) + 'deg'); });
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }
})();
